<template>
  <p class="text-sm text-center text-secondary-600 dark:text-darkblue-200">
    &copy;{{ currYear }} ZeroComa - {{ version }} 
    <span>
      - 
      <span class="text-primary-800 cursor-pointer hover:text-primary-900 hover:bg-primary-100 dark:hover:bg-darkblue-800 rounded" @click="openAccesibility" tabIndex="0">
        {{ $t('app.accessibility_dialog_title') }}
      </span> 
    </span>
  </p>
</template>

<script>
export default {
  name: 'copy',
  data: function () {
    return {
      currYear: '...',
      version: process.env.VUE_APP_VERSION
    }
  },
  created: function () {
    this.setDate()
  },
  methods: {
    setDate: function () {
      const date = new Date()
      this.currYear = date.getFullYear()
    },
    openAccesibility: function () {
      window.open(window.location.origin + '/files/EdasNEO-Declaracion-Accesibilidad.pdf')
    }
  }
}
</script>
